module.exports = __webpack_public_path__ + "static/media/schuettler_ohne_active.35fe4d7e.jpg";